import React, { useState, useEffect } from "react";

import { Route, Routes } from "react-router-dom";

// Import Routes all
import { userRoutes, authRoutes } from "./routes/allRoutes";

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";
import Sanatera from 'pages/Online/Dogovora/Sanatera/sanatera';
import Feeriya from 'pages/Online/Dogovora/Feeriya/feeriya';
import Liberty from 'pages/Online/Dogovora/Liberty/liberty';
import M1 from 'pages/Online/Dogovora/M1/m1';

const App = () => {
	const Layout = VerticalLayout;

	return (
		<React.Fragment>
			<Routes>
				{authRoutes.map((route, idx) => (
					<Route
						path={route.path}
						element={
							<NonAuthLayout>
								{route.component}
							</NonAuthLayout>
						}
						key={idx}
						isAuthProtected={false}
					/>
				))}

				{userRoutes.map((route, idx) => (
					<Route
						path={route.path}
						element={
							<Authmiddleware>
								<Layout>
									{route.component}
								</Layout>
							</Authmiddleware>
						}
						key={idx}
						isAuthProtected={true}
						exact
					/>
				))}

				<Route>
					<Route path="online/dogovora/sanatera" element={<Sanatera />} />
					<Route path="online/dogovora/feeriya" element={<Feeriya />} />
					<Route path="online/dogovora/liberty" element={<Liberty />} />
					<Route path="online/dogovora/m1" element={<M1 />} />
				</Route>
			</Routes>
		</React.Fragment>
	);
};

export default App;